import React from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Box } from '@mui/material';

const ReportDataGrid = ({ reportData = [], exportData = [], columns = [], reportName }) => {
  // Add `id` if missing
  const rows = reportData.map((item, index) => ({
    id: index + 1,
    ...item,
  }));

  return (
    <Box sx={{ height: 300, width: '100%', overflowX: 'auto' }}>
      <Box sx={{ minWidth: 400 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5, 10]}
          components={{ Toolbar: GridToolbar }}
          disableSelectionOnClick
          density="comfortable"
          autoHeight
        />
      </Box>
    </Box>
  );
};

export default ReportDataGrid;
